/** Códigos API para Tipo de Artículo (mismo criterio que inventario/productos). Valor persistido → etiqueta UI. */
export const TIPO_ARTICULO_OPTIONS: { value: string; label: string }[] = [
  { value: 'MP', label: 'Materia Prima' },
  { value: 'RV', label: 'Re-Venta' },
  { value: 'VD', label: 'Venta Directa' },
  { value: 'FIN', label: 'Financiero' },
  { value: 'SER', label: 'Servicio' },
  { value: 'DIS', label: 'Discontinuado' },
  { value: 'AFO', label: 'Aforadores' },
  { value: 'KIT', label: 'Articulo KIT' },
  { value: 'PT', label: 'Producto Terminado' },
  { value: 'INA', label: 'Inactivo' },
];

export function labelTipoArticulo(codigo: string | null | undefined): string {
  if (codigo == null || codigo === '') return '—';
  const found = TIPO_ARTICULO_OPTIONS.find((o) => o.value === codigo);
  return found?.label ?? codigo;
}
